// Columnas de la tabla de la Lista Maestra. Por defecto, las del mockup aprobado (02);
// los campos que pidió la reunión (QA F1 #10: tipo, proceso, aprobación, aplicable
// desde, frecuencia y relacionados) son opcionales: se muestran con el selector
// "Columnas" para no forzar el desplazamiento lateral. En archivo propio para no romper
// el fast-refresh; la tabla, su skeleton y el selector comparten esta lista.

export type ColumnId =
  | 'code'
  | 'title'
  | 'type'
  | 'process'
  | 'version'
  | 'status'
  | 'norms'
  | 'responsible'
  | 'owner'
  | 'approval'
  | 'effective'
  | 'frequency'
  | 'nextReview'
  | 'related';

export interface ColumnDef {
  id: ColumnId;
  label: string;
  /** Se puede ocultar (no está en el mockup). */
  optional: boolean;
}

export const COLUMN_DEFS: readonly ColumnDef[] = [
  { id: 'code', label: 'Código', optional: false },
  { id: 'title', label: 'Documento', optional: false },
  { id: 'type', label: 'Tipo', optional: true },
  { id: 'process', label: 'Proceso', optional: true },
  { id: 'version', label: 'Ver.', optional: false },
  { id: 'status', label: 'Estado', optional: false },
  { id: 'norms', label: 'Norma(s)', optional: false },
  { id: 'responsible', label: 'Responsable', optional: false },
  // Dueño de proceso (G3-3): opcional, a demanda.
  { id: 'owner', label: 'Dueño de proceso', optional: true },
  { id: 'approval', label: 'Aprobación', optional: true },
  { id: 'effective', label: 'Aplicable desde', optional: true },
  { id: 'frequency', label: 'Frecuencia', optional: true },
  { id: 'nextReview', label: 'Próx. revisión', optional: false },
  { id: 'related', label: 'Relacionados', optional: true },
];

export const OPTIONAL_COLUMNS: readonly ColumnDef[] = COLUMN_DEFS.filter((c) => c.optional);

export const DEFAULT_VISIBLE: readonly ColumnId[] = COLUMN_DEFS.filter((c) => !c.optional).map(
  (c) => c.id,
);

export function isColumnId(id: string): id is ColumnId {
  return COLUMN_DEFS.some((c) => c.id === id);
}

/** Columnas a mostrar, en el orden de la tabla: las fijas siempre, más las opcionales
 *  pedidas. Ids desconocidos se ignoran. */
export function visibleDefs(ids: readonly string[]): ColumnDef[] {
  const wanted = new Set(ids);
  return COLUMN_DEFS.filter((c) => !c.optional || wanted.has(c.id));
}
